import { useGoBack } from '../lib/hooks';
import { telegram } from '../lib/telegram';

/**
 * Tombol kembali dalam app.
 *
 * Di dalam Telegram komponen ini TIDAK menggambar apa pun: Telegram sudah
 * menyediakan tombol kembali sendiri di chrome-nya (disambungkan ke riwayat
 * app lewat TelegramBackSync di App.tsx), jadi menggambar tombol lagi hanya
 * menghasilkan dua tombol dengan fungsi sama.
 *
 * Di browser biasa tidak ada tombol itu, jadi tombol ini tetap tampil supaya
 * pengguna tidak kehilangan jalan kembali.
 */
export function BackButton({
  className = '',
  light = false,
}: {
  className?: string;
  /** Pakai stroke putih penuh — untuk di atas gambar/backdrop. */
  light?: boolean;
}) {
  const goBack = useGoBack();

  if (telegram.isInTelegram) return null;

  return (
    <button
      type="button"
      onClick={goBack}
      aria-label="Kembali"
      className={`grid h-11 w-11 place-items-center ${className}`}
    >
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        className={
          light
            ? 'text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.7)]'
            : 'text-neutral-300'
        }
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 5l-7 7 7 7" />
      </svg>
    </button>
  );
}
